import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=4f58a2a1&"
import script from "./Downloads.vue?vue&type=script&lang=js&"
export * from "./Downloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f58a2a1')) {
      api.createRecord('4f58a2a1', component.options)
    } else {
      api.reload('4f58a2a1', component.options)
    }
    module.hot.accept("./Downloads.vue?vue&type=template&id=4f58a2a1&", function () {
      api.rerender('4f58a2a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Downloads.vue"
export default component.exports